import React, { useEffect, useRef, useState, useCallback } from 'react';
import './pricelist.css';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { getFlightSearchListData, getPriceListListData } from '../../services/userservice';
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";


const PriceList = () => {

  const [selectedDate, setSelectedDate] = useState(new Date()); // Set initial date state
  const [toCity, setToCity] = useState('Hydrabad');
  const [adults, setAdults] = useState(1);
  const [children, setChildren] = useState(0);
  const [infants, setInfants] = useState(0);
  const [travelerSummary, setTravelerSummary] = useState(''); // State to manage traveler summary text
  const [showPopup, setShowPopup] = useState(false);
  const [results, setResults] = useState([]); // State for storing flight results
  const [showDropdownFrom, setShowDropdownFrom] = useState(false);
  const [selectDataFrom, setSelectDataFrom] = useState(null);
  const dropdownRef = useRef(null);
  const dropdownRefTo = useRef(null);
  const inputRef = useRef(null);
  const inputRefTo = useRef(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [flightList, setFlightList] = useState([]);
  const [showDropdownTo, setShowDropdownTo] = useState(false);
  const [selectDataTo, setSelectDataTo] = useState(null);
  const [searchTermTo, setSearchTermTo] = useState('');
  const [flightListTo, setFlightListTo] = useState([]);
  const [loading, setLoading] = useState(false);
  const gridApiRef = useRef(null);

  const totalTravelers = adults + children + infants;


  const debounce = (func, delay) => {
    let debounceTimer;
    return function (...args) {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => func(...args), delay);
    };
  };

  const handleDateChange = (date) => {
    setSelectedDate(date); // Update state with selected date
  };

  const togglePopup = () => {
    setShowPopup(!showPopup);
  };

  const handleDone = () => {
    setShowPopup(false);

    // Build the traveler summary text
    const summary = [
      `${adults} Adult${adults > 1 ? "s" : ""}`,
      children > 0 ? `${children} Child${children > 1 ? "ren" : ""}` : "",
      infants > 0 ? `${infants} Infant${infants > 1 ? "s" : ""}` : "",
    ]
      .filter(Boolean) // Removes empty strings
      .join(", ");

    // Update the traveler summary state
    setTravelerSummary(summary);
  };

  const handleIncrement = (type) => {
    if (totalTravelers < 9) {
      if (type === "adult") setAdults(adults + 1);
      if (type === "child" && children < adults) setChildren(children + 1);
      if (type === "infant") setInfants(infants + 1);
    }
  };

  const handleInputChange = (e) => {
    setSearchTerm(e.target.value);
    fetchCountryList(e.target.value);
  };
  const fetchCountryList = useCallback(
    debounce(async (term) => {
      if (term) {
        try {
          const data = await getFlightSearchListData(term);
          setFlightList(data);
        } catch (error) {
          console.error('Failed to fetch flight list', error);
        }
      }
    }, 500),
    []
  );
  const fetchCountryListTo = useCallback(
    debounce(async (term) => {
      if (term) {
        try {
          const data = await getFlightSearchListData(term);
          setFlightListTo(data);
        } catch (error) {
          console.error('Failed to fetch flight list', error);
        }
      }
    }, 500),
    []
  );

  const handleDecrement = (type) => {
    if (type === "adult") {
      const newAdults = Math.max(adults - 1, 1); // Ensure at least 1 adult
      setAdults(newAdults);

      // Adjust children if necessary
      if (children > newAdults) setChildren(newAdults);
    }
    if (type === "child") setChildren(Math.max(children - 1, 0));
    if (type === "infant") setInfants(Math.max(infants - 1, 0));
  };

  // Function to call API on search click
  const handleSearch = async () => {
    setLoading(true)
    const requestData = {
      cabinClass: 'ALL', //travelClass.toUpperCase(),
      routeInfos: [
        {
          fromCityOrAirport: { code: selectDataFrom?.code },
          toCityOrAirport: { code: selectDataTo?.code },
          travelDate: selectedDate.toISOString().split('T')[0]
        }
      ],
      paxInfo: {
        ADULT: "1", //adults.toString(),
        CHILD: "0", //children.toString(),
        INFANT: "0", //infants.toString(),
      }
    };
    try {
      //const response =  getPriceListListData(requestData);
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}vendor-flight/price-list/oneway`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'api-key': process.env.REACT_APP_SMT_V2_API_KEY
        },
        body: JSON.stringify(requestData),
      });
      if (response.ok) {
        const data = await response.json();
        const resultsData = data?.results?.map((flight, index) => ({
          id: index + 1,
          flight: flight?.airline + " " + flight?.flightNumber,
          cabinClass:flight?.priceOptions[0]?.cabinClass || 'NA',
          PublishedPrice: flight?.priceOptions[0]?.fare?.PublishedFare || 'NA',
          OfferedPrice: flight?.priceOptions[0]?.fare?.OfferedFare || 'NA',
          AgentCommission: flight?.priceOptions[0]?.fare?.CommissionEarned || 'NA',
        })) || [];
        setResults(resultsData); // Update the results state with API response data
      } else {
        console.error('API request failed');
      }
    } catch (error) {
      console.error('Error during API call:', error);
    } finally {
      setLoading(false);
    }
  };
  const handleSelectFrom = (flight) => {
    setSelectDataFrom(flight);
    setShowDropdownFrom(false);
  }
  const handleSelectTo = (flight) => {
    setSelectDataTo(flight);
    setShowDropdownTo(false);
  }
  const handleInputChangeTo = (e) => {
    setSearchTermTo(e.target.value);
    fetchCountryListTo(e.target.value);
  };
  const onGridReady = (params) => {
    gridApiRef.current = params.api;
  };

  const exportCsv = () => {
    if (gridApiRef.current) {
      gridApiRef.current.exportDataAsCsv({ fileName: "FlightPriceList.csv" });
    }
  };

  const columnDefs = [
    { field: "id", headerName: "S. No.", sortable: true, filter: false,width: 80 },
    { field: "flight", headerName: "Flight", sortable: true, filter: true },
    { field: "cabinClass", headerName: "CabinClass", sortable: true, filter: true },
    { field: "PublishedPrice", headerName: "User Price", sortable: true, search: true , width: 150},
    { field: "OfferedPrice", headerName: "Offered Price", sortable: true, filter: true , width: 150},
    { field: "AgentCommission", headerName: "Commission Earned", sortable: true, filter: true, width: 200  }
  ];
  return (
    <>
      <section className="content-wrapper">
        <div className="content-header">
          <div className="Banner_cntr">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <div className="card">
                    <div className="card-body pb-0 flight_search text-center rounded-bottom-4">
                      <div className="row box">
                        <div className="col-lg-12">
                          <div className="row flight_change">
                            <div className="col-md-4 pe-md-1">
                              <div className="form-group">
                                <label className='from-title cursor-pointer'>From City</label>
                                <button
                                  className='flight_from-search-btn'
                                  aria-label="Select City"
                                  onClick={() => setShowDropdownFrom(!showDropdownFrom)}
                                >
                                  <span className='flight-select-title'>{selectDataFrom?.city || "Select City"}</span>
                                  <span className='flight-select-subtitle text-truncate d-block'>{selectDataFrom?.name ? selectDataFrom?.name : "Country"}</span>
                                </button>
                                {showDropdownFrom && (
                                  <div ref={dropdownRef} className="search-list-container">
                                    <input
                                      placeholder="From ..."
                                      ref={inputRef}
                                      value={searchTerm}
                                      onChange={handleInputChange}
                                      style={{ height: "60px" }}
                                    />
                                    {flightList?.data?.length > 0 && (
                                      <div className="popular-cities">
                                        <h4>Suggested Cities</h4>
                                      </div>
                                    )}
                                    <ul className='search-list'>
                                      {flightList?.data?.map((city, index) => (
                                        <li key={index} onClick={() => handleSelectFrom(city)} className="flight-item">
                                          <span className="airportTitle">{`${city.city} (${city.cityCode})`}</span>
                                          <span className="airportSubTitle">{city.name}</span>
                                        </li>
                                      ))}
                                    </ul>
                                  </div>
                                )}
                              </div>
                            </div>
                            <div className="col-md-4 pe-md-1 ps-md-1">
                              <div className="form-group">
                                <label className='from-title cursor-pointer'>To City</label>
                                <button
                                  className='flight_from-search-btn'
                                  aria-label="Select To City"
                                  onClick={() => setShowDropdownTo(!showDropdownTo)}
                                >
                                  <span className='flight-select-title'>{selectDataTo?.city || "Select City"}</span>
                                  <span className='flight-select-subtitle text-truncate d-block'>{selectDataTo?.name ? selectDataTo?.name : "Country"}</span>
                                </button>
                                {showDropdownTo && (
                                  <div ref={dropdownRefTo} className="search-list-container">
                                    <input
                                      placeholder="To ..."
                                      ref={inputRefTo}
                                      value={searchTermTo}
                                      onChange={handleInputChangeTo}
                                      style={{ height: "60px" }}
                                    />
                                    {flightListTo?.data?.length > 0 && (
                                      <div className="popular-cities">
                                        <h4>Suggested Cities</h4>
                                      </div>
                                    )}
                                    <ul className='search-list'>
                                      {flightListTo?.data?.map((city, index) => (
                                        <li key={index} onClick={() => handleSelectTo(city)} className="flight-item">
                                          <span className="airportTitle">{`${city.city} (${city.cityCode})`}</span>
                                          <span className="airportSubTitle">{city.name}</span>
                                        </li>
                                      ))}
                                    </ul>
                                  </div>
                                )}
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label>
                                  <i className="fa fa-calendar" /> Departure
                                </label>
                                <DatePicker
                                  id="datepicker"
                                  selected={selectedDate}
                                  onChange={handleDateChange}
                                  dateFormat="dd/MM/yyyy"
                                  className="form-control"
                                />
                                <span>{selectedDate.toDateString()}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <a
                        href="#"
                        className="btn btn-primary search_btn"
                        onClick={handleSearch}
                      >
                        Search
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="searchbar">
            <div className="container">
              <div className="card">
                <div className="card-header d-md-flex justify-content-between">
                {results.length > 0 && (
                <button className='export-csv-btn' onClick={exportCsv} disabled={results.length === 0}>
                  Export CSV
                </button>)}
                </div>
                <div className="card-body">
                <div className="ag-theme-alpine" style={{ height: 800, width: "100%" }}>
                  {loading ? (
                    <div className="preloader">
                      <div className="loader"></div>
                      <div className="loader-text">Loading...</div>
                    </div>
                  ) : (
                    <AgGridReact
                      rowData={results} // Should be an array of objects
                      columnDefs={columnDefs}
                      pagination={true}
                      paginationPageSize={20}
                      enableCsvExport={true}
                      onGridReady={onGridReady}
                    />
                  )}
                </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </section>
    </>
  );
};

export default PriceList;
